import React from 'react';
import { Nav } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"

// `locked` true iken adımlar tıklanamaz hale gelir (sadece etiket olarak gösterilir).
// Sipariş tamamlandıktan sonraki ekranlarda (OrderScreen/Completed) kullanıcının
// Sevkiyat/Ödeme Şekli adımlarına geri dönüp değişiklik yapmaya çalışmasını
// engellemek için kullanılır.
const Step = ({ active, locked, to, label }) => (
  <div className={active ? 'active' : ''}>
    {locked ? (
      <span className="nav-link">{label}</span>
    ) : (
      <LinkContainer to={to}>
        <Nav.Link>{label}</Nav.Link>
      </LinkContainer>
    )}
  </div>
);

export default function CheckoutStatusBar1(props) {
 return (
  <div className="checkout-steps">
   <Step active={props.step2} locked={props.locked} to='/shipping' label='Sevkiyat' />
   <Step active={props.step3} locked={props.locked} to='/payment' label='Ödeme Şekli' />
   <Step active={props.step4} locked={props.locked} to='/placeorder' label='Sipariş/Teklif' />
  </div>
 )
}
